import {deepCopy} from "../utils";

export const FormNotification = {
  methods: {
    notifySuccess(callback) {
      const message = this.successMessage || this.$i18n.t('Form submitted success');
      // console.log(message);
      this.$notify({
        verticalAlign: 'top',
        type: 'success',
        horizontalAlign: 'center',
        message
      });
      setTimeout(callback, 1000);
    },
    notifyError(callback) {
      const message = this.errorMessage || this.$i18n.t('Form submitting error!');
      console.error(message);
      this.$notify({
        verticalAlign: 'top',
        type: 'warning',
        horizontalAlign: 'center',
        message
      });
      setTimeout(callback, 1000);
    }
  }
}

export const FormSubmitHandlers = {
  data() {
    return {
      submitRedirectTo: {path: undefined}
    }
  },
  computed: {
    loading() {
      return this.status === 1
    }
  },
  watch: {
    'status': function (val, oldval) {
      // console.log('val', val, 'oldval', oldval);
      if (val !== oldval) {
        if (val === 2) this.handleSuccess();
        if (val === 3) this.handleError()
        // console.log('watched status changed:', val)
      }
    }
  },
  methods: {
    revertStatus() {
      console.warning('Method should be implemented ' +
        'on a component to revert submitting status to default value = 0')
    },
    async handleSuccess() {
      this.notifySuccess(
        () => {
          this.revertStatus();
          if (this.submitRedirectTo) {
            this.$router.push(this.submitRedirectTo);
          }
        }
      )
    },
    async handleError() {
      this.notifyError(
        () => {
          this.revertStatus();
        }
      )
    },
  }
}

export const FormEdit = {
  data() {
    return {
      waiterKeyword: 'form data prefetching'
    }
  },
  computed: {
    vuexModel() {
      return {}
    },
    form() {
      return this.model
    }
  },
  async created() {
    this.$wait.start(this.waiterKeyword);
    await this.loadPredefined();
    await this.load({
      urlParams: this.$route.params
    });
    this.predefineValues();
    this.$wait.end(this.waiterKeyword);
  },
  methods: {
    predefineValues() {
      this.model = {
        ...deepCopy(this.vuexModel)
      }
    },
    formSubmit() {
      this.save({
        urlParams: this.$route.params,
        form: this.form
      });
    },
    async loadPredefined() {
      await setTimeout(() => {
        console.log('here can be loaded predefined values for form widgets')
      }, 100)
    }
  }
}
